/* global window */
import { supportLocalStorage } from 'Helpers/localStorage';
import * as locationOnboardingConstants from 'Components/LocationOnboarding/constants';

export const setlocationOnboardingStatus = locationOnboardingStatus => {
    return {
        type: 'SET_LOCATION_ONBOARDING_STATUS',
        data: locationOnboardingStatus
    };
};

export const intializelocationOnboardingStatus = () => {
    return dispatch => {
        let locationOnboardingStatus;
        let oldlocationOnboardingStatusFlag;

        if (supportLocalStorage()) {
            // this is for old RC versions, we need to update this flag, this code will be removed in further releases
            oldlocationOnboardingStatusFlag = window.localStorage.getItem(locationOnboardingConstants.DEPRECATED_LOCATION_ONBOARDING_STATUS);
            if (oldlocationOnboardingStatusFlag) {
                window.localStorage.setItem(locationOnboardingConstants.LOCATION_ONBOARDING_STATUS, locationOnboardingConstants.ACCEPTED);
                window.localStorage.removeItem(locationOnboardingConstants.DEPRECATED_LOCATION_ONBOARDING_STATUS);
            }

            locationOnboardingStatus = window.localStorage.getItem(locationOnboardingConstants.LOCATION_ONBOARDING_STATUS);
        }

        if (!locationOnboardingStatus) {
            locationOnboardingStatus = locationOnboardingConstants.UNACCEPTED;
        }

        dispatch(setlocationOnboardingStatus(locationOnboardingStatus));
    };
};

export const userLocationOnboarded = () => dispatch => {
    if (supportLocalStorage()) {
        window.localStorage.setItem(locationOnboardingConstants.LOCATION_ONBOARDING_STATUS, locationOnboardingConstants.ACCEPTED);
    }
    dispatch(setlocationOnboardingStatus(locationOnboardingConstants.ACCEPTED));
};
